import { render } from "./realEstateBulletin.vue?vue&type=template&id=0fd3d3ac"
import script from "./realEstateBulletin.vue?vue&type=script&lang=js"
export * from "./realEstateBulletin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__